// import React from "react";
// import ReminderChannels from "./ReminderChannels";
// import "../../../../../../css/pages/ca_pages/finances/models/client_payments_model/ReminderItem.css";

import React from "react";

import ReminderChannels from "./ReminderChannels";
import ReminderMessageEditor from "./ReminderMessageEditor";
import ReminderPlatformMessages from "./ReminderPlatformMessages";

const ReminderItem = ({
    reminder,
    index,
    errors,
    canRemove,
    onRemove,
    onDuplicate,
    onUpdate,
}) => {
    const update = (changes) => {
        onUpdate(reminder.id, changes);
    };

    const togglePlatformCustomization = () => {
        update({ customizePlatforms: !reminder.customizePlatforms });
    };

    return (
        <div className="reminder-item">
            {/* HEADER */}
            <div className="reminder-item-header">
                <div>
                    <span className="reminder-number">
                        REMINDER {index + 1}
                    </span>

                    <h4>
                        Scheduled reminder
                    </h4>
                </div>

                <div className="reminder-actions">
                    <button
                        type="button"
                        onClick={() => onDuplicate(reminder.id) }
                    >
                        Duplicate
                    </button>

                    {canRemove && (
                        <button
                            type="button"
                            className="danger-action"
                            onClick={() => onRemove(reminder.id) }
                        >
                            Remove
                        </button>
                    )}
                </div>
            </div>

            {/* DATE + TIME */}
            <div className="reminder-date-time-grid">
                <div className="form-group">
                    <label>
                        Date
                        <span className="required-mark">
                            *
                        </span>
                    </label>

                    <input
                        type="date"
                        value={ reminder.date }
                        onChange={(e) => update({ date: e.target.value }) }
                        className={
                            errors[`reminder_${reminder.id}_date`]
                                ? "input-error" : ""
                        }
                    />

                    {errors[
                        `reminder_${reminder.id}_date`
                    ] && (
                        <small className="field-error">
                            { errors[`reminder_${reminder.id}_date`] }
                        </small>
                    )}
                </div>

                <div className="form-group">
                    <label>
                        Time
                        <span className="required-mark">
                            *
                        </span>
                    </label>

                    <input
                        type="time"
                        value={ reminder.time }
                        onChange={(e) => update({ time: e.target.value }) }
                    />

                    {errors[
                        `reminder_${reminder.id}_time`
                    ] && (
                        <small className="field-error">
                            { errors[`reminder_${reminder.id}_time`] }
                        </small>
                    )}
                </div>
            </div>

            {/* CHANNELS */}
            <ReminderChannels
                channels={ reminder.channels }
                onChange={(channels) => update({ channels }) }
            />

            {/* MESSAGE */}
            {!reminder.customizePlatforms && (
                <ReminderMessageEditor
                    reminder = { reminder }
                    error    = { errors[`reminder_${reminder.id}_message`] }
                    onUpdate = { update }
                />
            )}

            {/* PLATFORM CUSTOMIZATION */}
            <label className="platform-customization-toggle">
                <input
                    type="checkbox"
                    checked={ reminder.customizePlatforms }
                    onChange={ togglePlatformCustomization }
                />

                <span>
                    Customize message for each platform differently
                </span>

                <span
                    className="info-tooltip"
                    title="Create different messages for Email, WhatsApp and SMS."
                >
                    ?
                </span>
            </label>

            {reminder.customizePlatforms && (
                <ReminderPlatformMessages
                    reminder={reminder}
                    onUpdate={update}
                />
            )}
        </div>
    );
};

export default ReminderItem;
